import SurveyBaseController from './survey_base_controller';
import db from '../../field_db'

export default class extends SurveyBaseController {
  static values = {
    surveyableType: String,
    surveyableId: String
  }

  static targets = ["loader"]

  connect() {
    super.connect();
    this.survey = this.initializeSurvey('display');
    this.viewSurvey();
  }

  viewSurvey() {
    fetch(`/api/v1/surveys/results/results.json?surveyable_id=${this.surveyableIdValue}&surveyable_type=${this.surveyableTypeValue}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
      })
      .then(response => {
        if (!response.ok) throw new Error("Failed to fetch survey");
        return response.json();
      })
      .then(data => {
        if (data.survey !== null) {
          this.survey.fromJSON(data.survey);
          this.survey.data = data.result;

          const el = document.getElementById(`${this.surveyableTypeValue.toLowerCase()}_${this.surveyableIdValue}_survey_result_display`);
          this.survey.render(el);

          if (this.hasLoaderTarget) this.loaderTarget.remove();
        }
      })
      .catch(async error => {
        console.error("Error loading survey:", error);
        await this._renderFromCache();
      });
  }

  async _renderFromCache() {
    if (this.surveyableTypeValue !== "Response") {
      if (this.hasLoaderTarget) this.loaderTarget.remove()
      return
    }

    const cached = await db.cached_responses
      .where("responseId").equals(parseInt(this.surveyableIdValue))
      .first()
      .catch(() => null)

    if (cached?.surveyJson) {
      this.survey.fromJSON(cached.surveyJson)
      this.survey.data = cached.resultJson || {}
      const el = document.getElementById(`${this.surveyableTypeValue.toLowerCase()}_${this.surveyableIdValue}_survey_result_display`)
      if (el) this.survey.render(el)
    }

    if (this.hasLoaderTarget) this.loaderTarget.remove()
  }
}
